import StewardAssetNewPage from './StewardAssetNewPage';

export default StewardAssetNewPage;
